import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { IKnmErknmFormActExpert } from '../interfaces/IKnmErknmFormActExpert';

export const convertActExpertsFormValueToKnmData = (
  experts: IKnmErknmFormActExpert[] | undefined,
): IKnm248['experts'] => {
  if (!experts) {
    return null;
  }

  return experts
    .filter(i => i.expert)
    .map(item => ({
      title: item.expert?.value.title || null,
      type: item.expert?.value.type ? deleteObjectProperties(item.expert?.value.type, ['label', 'value']) : null,
      guid: item.expert?.value.guid || null,
      dateCreate: item.expert?.value.dateCreate || null,
    }));
};
